// Vimeo entries SHOULD provide `posterOverride`. Without it, the facade renders
// with no thumbnail image (background colour only) — Vimeo has no deterministic
// thumbnail URL scheme and runtime oEmbed lookup would violate VIDE success
// criterion 5 (zero requests to vimeo.com on first load).
import { resolveStrapiMediaUrl } from '../../../core/utils/strapi-media.util';

export function adaptVideoEmbedBlock(
  entry: Record<string, unknown>,
  baseUrl: string,
): Record<string, unknown> {
  const poster = entry['posterOverride'] as Record<string, unknown> | null;
  const posterUrl = poster
    ? resolveStrapiMediaUrl(baseUrl, (poster['url'] as string) ?? null)
    : null;

  const providerRaw = (entry['provider'] as string) ?? 'youtube';
  const provider: 'youtube' | 'vimeo' =
    providerRaw === 'vimeo' ? 'vimeo' : 'youtube';

  return {
    provider,
    videoId: (entry['videoId'] as string) ?? '',
    title: (entry['title'] as string) ?? '',
    caption: (entry['caption'] as string) ?? '',
    fullWidth: Boolean(entry['fullWidth']),
    posterUrl,
    uploadDate: (entry['uploadDate'] as string) ?? '',
  };
}
